import { jsx as _jsx } from "react/jsx-runtime";
import './ScoreBoard.scss';
// Panel Label
const PanelLabel = ({ children }) => (_jsx("dt", { className: "scoreboard-panel-label", children: children }));
// Panel Value
const PanelValue = ({ children }) => (_jsx("dd", { className: "scoreboard-panel-value", children: children }));
const Panel = (({ children, className }) => {
    return _jsx("dl", { className: `scoreboard-panel ${className}`, children: children });
});
Panel.Label = PanelLabel;
Panel.Value = PanelValue;
// ScoreBoard
export const ScoreBoard = ({ children }) => (_jsx("div", { className: "scoreboard", children: _jsx("div", { className: "page-dim", children: children }) }));
ScoreBoard.Panel = Panel;
